export default "__VITE_ASSET__CDCP4CW___"